import React from 'react';

import { createSvgIcon } from '@mui/material/utils';

const LayerIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17">
        <path d="M8.51489 0.181641L1.51489 3.94054L8.51489 7.69944L15.5149 3.94054L8.51489 0.181641Z" />
        <path d="M1.51489 8.18164L3.46572 7.13408L8.51489 9.84541L13.5641 7.13408L15.5149 8.18164L8.51489 11.9405L1.51489 8.18164Z" />
        <path d="M1.51489 12.4227L3.46572 11.3752L8.51489 14.0865L13.5641 11.3752L15.5149 12.4227L8.51489 16.1816L1.51489 12.4227Z" />
    </svg>,
    'LayerIcon'
);

export default LayerIcon;
